import { render, staticRenderFns } from "./NewChildButton.vue?vue&type=template&id=450b5ceb&scoped=true&"
import script from "./NewChildButton.vue?vue&type=script&lang=js&"
export * from "./NewChildButton.vue?vue&type=script&lang=js&"
import style0 from "./NewChildButton.vue?vue&type=style&index=0&id=450b5ceb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450b5ceb",
  null
  
)

export default component.exports